<template>
  <div
    class="good-item"
    @click="showDetail"
  >
    <div class="good-item-flex">
      <div class="good-img">
        <img :src="good.imageInfo.imageList[0].url" />
      </div>
      <div class="good-info">
        <div class="title">{{ good.skuName }}</div>
        <div class="coupon-info">
          <div class="item" v-if="couponPrice>0">券￥{{ couponPrice }}</div>
          <div class="item">已售{{ good.inOrderCount30DaysSku }}件</div>
        </div>
        <div class="price-content">
          <div class="price">
            劵后￥{{ good.priceInfo.lowestCouponPrice }}
          </div>
          <div class="original-price">￥{{ good.priceInfo.price }}</div>
        </div>
        <div class="btn" @click.stop="doCopy(good)">
          <!-- 赚￥{{ promotion_rate }} -->
          前往购买
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    good: Object,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["rate"]),
    // 优惠券价格
    couponPrice(){
        const price = (this.good.priceInfo.price*100) - (this.good.priceInfo.lowestCouponPrice * 100);
        return Number((price/100).toFixed(2));
    },
    promotion_rate() {
      return (
        (this.good.commissionInfo.couponCommission *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  methods: {
    // 查看商品详情
    showDetail(){
      window.localStorage.setItem('jdGoodInfo',JSON.stringify(this.good))
      this.$router.push('/jd/detail?id=' + this.good.skuId)
    },
    // 复制链接
    doCopy(item) {
      this.$router.push({
        path: "/jd/share",
        query: {
          id: item.skuId,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.good-item {
  padding: 5px 10px;
  .good-item-flex {
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    position: relative;
    .good-img {
      width: 96px;
      img {
        width: 96px;
        border-radius: 10px 0 0 10px;
      }
    }
    .good-info {
      flex: 1;
      padding: 5px 8px;
      .title {
        color: #000;
      }
      .coupon-info {
        display: flex;
        padding: 4px 0;
        .item {
          border-radius: 4px;
          padding: 0 6px;
          font-size: 10px;
          border: 1px solid #ee0a24;
          color: #ee0a24;
          margin-right: 4px;
        }
      }
      .price-content {
        .price {
          color: #ee0a24;
        }
        .original-price {
          font-size: 10px;
          color: #999;
          text-decoration: line-through;
        }
      }
      .btn {
        position: absolute;
        padding: 0 15px;
        background: #ee730a;
        color: #ffffff;
        font-size: 14px;
        border-radius: 16px 0 0 16px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        right: 0;
        bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jd/good.vue